import { render, staticRenderFns } from "./AsideTools.vue?vue&type=template&id=25b6415c&"
import script from "./AsideTools.vue?vue&type=script&lang=js&"
export * from "./AsideTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports